import {
  Directive,
  Input,
  ViewContainerRef,
  OnChanges,
  Type,
  SimpleChanges, ComponentRef,
} from '@angular/core';

export interface IDynamicComponentConfig {
  // tslint:disable-next-line:no-any
  ref: Type<any>;
  // tslint:disable-next-line:no-any
  inputs: { [p: string]: any };
}

@Directive({
  selector: '[dynamicHost]'
})
export class DynamicHostDirective implements OnChanges {
  @Input('dynamicHost') config!: IDynamicComponentConfig;

  // tslint:disable-next-line:no-any
  private componentRef?: ComponentRef<any>;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config) {
      this.loadComponent();
    }
  }

  private loadComponent() {
    this.viewContainerRef.clear();

    if (this.config.ref) {
      this.componentRef = this.viewContainerRef.createComponent(this.config.ref);

      if (this.config.inputs) {
        for (const [key, value] of Object.entries(this.config.inputs)) {
          this.componentRef.instance[key] = value;
        }
      }

    }
  }
}
